import { logWarning } from "../../../../../monitoring";

export default ({ selectedColourWayId = null, images }) => {
  if (selectedColourWayId === null) return null;

  const image = images.find(image => image.colourWayId === selectedColourWayId);
  if (image === undefined) {
    logWarning(`image for ${selectedColourWayId} not found`);

    return null;
  }

  return {
    imageUrl: image.url
  };
};
